'use client'

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { ProductFormatted } from '@/types/product'
import { useTranslations } from 'next-intl'
import { AmazonCarouselProductCard } from './amazon-carousel-product-card'

export function AmazonProductCardCarousel({
  products,
  gaTrackingValue,
  gaTrackingLabel,
  isSoldProduct,
}: {
  products: ProductFormatted[]
  gaTrackingValue?: string
  gaTrackingLabel?: string
  isSoldProduct?: boolean
}) {
  if (!products.length) return <EmptyProductCarousel />

  return (
    <Carousel
      opts={{
        align: 'start',
        duration: 50,
        slidesToScroll: 2,
        skipSnaps: true,
        loop: true,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        watchDrag: (_, event: any) => {
          const target = event?.target as HTMLElement
          const wrapper = target?.closest(
            '.color-variant-picker-wrapper'
          ) as HTMLElement | null

          if (wrapper) {
            const hasScroll = wrapper.scrollWidth > wrapper.clientWidth
            if (hasScroll) {
              return false // Chặn drag khi wrapper có scroll ngang
            }
          }

          return true // Cho phép drag nếu không có scroll
        },
      }}
      className='w-full'
    >
      <CarouselContent className='-ml-3'>
        {products.map((product, index) => (
          <CarouselItem
            key={product.id + index}
            className='basis-1/2 will-change-transform md:basis-1/3 lg:basis-1/4 xl:basis-1/5'
            data-product-id={product.id}
          >
            <AmazonCarouselProductCard
              product={product}
              gaTrackingValue={gaTrackingValue}
              gaTrackingLabel={gaTrackingLabel}
              isSoldProduct={isSoldProduct}
            />
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselNavigation />
    </Carousel>
  )
}

const EmptyProductCarousel = () => {
  const t = useTranslations()
  return (
    <div className='flex h-64 items-center justify-center rounded-lg bg-neutral-100'>
      <p className='text-neutral-500'>{t('common.no_product_found')}</p>
    </div>
  )
}

function CarouselNavigation() {
  return (
    <>
      <CarouselPrevious
        className='absolute -left-4 top-1/2 h-7 w-7 -translate-y-full lg:-left-10'
        variant='black'
        hideIfStart
        ga-tracking-value={`product-carousel__previous-arrow`}
        ga-tracking-label='previous_arrow'
      />
      <CarouselNext
        className='absolute -right-4 top-1/2 h-7 w-7 -translate-y-full lg:-right-10'
        variant='black'
        hideIfEnd
        ga-tracking-value={`product-carousel__next-arrow`}
        ga-tracking-label='next_arrow'
      />
    </>
  )
}
